export interface IUpgradeLogEntry {
    Id?: number;
    UpgradeOn?: string; //ISO 8601 Date
    UpgradeEndTime?: string; //ISO 8601 Date
    SecondsUntilUpgradeStart?: number;
    SecondsUntilUpgradeEnd?: number;
    UpgradeStatusType?: UpgradeStatusType;
    CustomerInformation?: string;
}

export enum UpgradeStatusType {
    Upcoming = 1,
    Completed = 2,
    Cancelled = 3,
}
